import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Container } from "@/views/components/Container";
import { InfoboxSection } from "@/views/components/Page";

import pageNotFound from "./assets/page_not_found.svg";
import { IWithHttpErrorProps } from "./types";

interface Props extends Pick<IWithHttpErrorProps, "fetch"> {}

export const Error5XX: FC<Props> = () => {
  const { t } = useTranslation("session");

  return (
    <Container>
      <InfoboxSection imgSrc={pageNotFound} heading={t("ERRORS.5XX.HEADER")} description={t("ERRORS.5XX.TEXT")} />
    </Container>
  );
};
